// src/pages/Logout/LogoutPage.tsx
import React from 'react';
import { TdsCard } from '@trv-tds/react';
import './LogoutPage.scss';

const LogoutPage: React.FC = () => {
  return (
    <div className="logout-page">
      <TdsCard className="logout-card">
        <div className="logout-content">
          <div className="logout-icon">✓</div>
          <h1>Logout Successful</h1>
          <p className="logout-message">
            Your session has been invalidated.
          </p>
          <p className="logout-instructions">
            Please close this browser window/tab and relaunch the application to start a new session.
          </p>
        </div>
      </TdsCard>
    </div>
  );
};

export default LogoutPage;
